import { resources } from "@constants/hardcoded-strings";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { updateIdentityProviderChangeRequestRequest } from "@requests/identity-provider";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getRemainingChangeRequestStatuses } from "@utils/change-request-modal-util/common-change-request-modal-util";
import { Dispatch } from "redux";

export const deployIdentityProviderChangeRequestReduxRequest = (dispatch: Dispatch) => async (
    identityProviderId: string,
    currentChangeRequestStatus: ChangeRequestStatusTypes
): Promise<ChangeRequestStatusTypes> => {

    const changeRequestStatuses = getRemainingChangeRequestStatuses(currentChangeRequestStatus);

    let hasChangeRequestStatusUpdateError = false;
    let requestIndex = 0;
    let lastSuccessfullChangerequestStatus: ChangeRequestStatusTypes = null;

    while (!hasChangeRequestStatusUpdateError && requestIndex < changeRequestStatuses.length) {
        const { data, error } = await updateIdentityProviderChangeRequestRequest(identityProviderId, {}, changeRequestStatuses[requestIndex]);

        if (data?.transferObject) {
            lastSuccessfullChangerequestStatus = changeRequestStatuses[requestIndex];
        } else if (error) {
            hasChangeRequestStatusUpdateError = true;
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.updateIdentityProviderChangeRequest.error.title,
                resources.requests.updateIdentityProviderChangeRequest.error.message,
            );
            lastSuccessfullChangerequestStatus = changeRequestStatuses[requestIndex];

            return changeRequestStatuses[requestIndex];
        }

        requestIndex++;
    }
    
    return lastSuccessfullChangerequestStatus;
};